import { Component, OnInit } from "@angular/core";
import { CustomerModel } from "../../common/viewModels/Admin/CustomerModel";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import { CustomHttp } from "../../common/customHttp.service";
import { ApiUrl } from "../../common/apiUrls";
import { PagerService } from "../../common/pagerService";
import { MainAppComponent } from "../../layout/layout.component";
import { ToastrService } from "ngx-toastr";
import { FormatService } from "../../common/formatService";
import { JobCardsListModel } from "../../common/viewModels/Analysis/SampleModel";

@Component({
  selector: "app-oil-analysis-report",
  templateUrl: "./oil-analysis-report.component.html",
  styleUrls: ["./oil-analysis-report.component.css"],
})
export class OilAnalysisReportComponent implements OnInit {
  customers: CustomerModel[] = [];
  customersTemp: CustomerModel[] = [];
  lstJobCards: JobCardsListModel[] = [];
  labs: any;
  searchForm: FormGroup;

  constructor(
    public _router: Router,
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _pagerService: PagerService,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
    private _formatService: FormatService,
  ) {}

  ngOnInit() {
    this.GetCustomers();
    this.GetLabs();
    this.createSearchForm();
    var currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    if (curUserDetails && curUserDetails.LabIds && curUserDetails.UserTypeId == 2) {
      this.searchForm.controls["LabIds"].setValue(
        JSON.parse(curUserDetails.LabIds),
      );
    }
    if (curUserDetails && curUserDetails.DefaultCompanyId) {
        this.searchForm.controls['CustomerId'].setValue(parseInt(curUserDetails.DefaultCompanyId));
    }
    this.BindJobCard(this.searchForm.controls["CustomerId"].value);
  }
  createSearchForm() {
    this.searchForm = this._formBuilder.group({
      // AreaId: [0],
      // Equipment: [''],
      // OilGradeId: [0],
      SampleNo: [""],
      SpId: [""],
      CustomerId: [""],
      LabIds: [""],
      JobCardNumber: [""],
      SampleStatusTypeId: [""],
    });
  }
  GetCustomers() {
    this._http.get(this._appUrl.GetCustomersMinInfoList).subscribe(
      (data: any) => {
        this.customers = data.json().Result;
        this.customersTemp = data.json().Result;
      },
      (error: any) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }
  BindJobCard(val: any) {
    this._http.post(this._appUrl.GetJobCardsByCustomer, [val]).subscribe(
      (data) => {
        if (data.json().Result != null) this.lstJobCards = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      },
    );
  }
  GetLabs() {
    this._http.get(this._appUrl.GetLabsMinInfoList).subscribe(
      (data) => {
        if(this._mApp.userTypeId == 2) {
            let lstLabs = data.json().Result;
            if (this._mApp.currentUserLabIds && lstLabs)
              lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
            this.labs = lstLabs;
          }
          else {
            this.labs = data.json().Result;
          }
      },
      (error) => {
        this._toastrService.error(error.json());
      },
    );
  }
 DownloadReport() {
    this._mApp.ShowLoader();

    const customerVal = this.searchForm.controls["CustomerId"].value;
    const jobCardVal = this.searchForm.controls["JobCardNumber"].value;
  const isCustomerEmpty =
    customerVal === 0 ||
    customerVal === "0" ||
    customerVal === "" ||
    customerVal === null ||
    customerVal === undefined;
  const isJobCardEmpty =
    jobCardVal === 0 ||
    jobCardVal === "0" ||
    jobCardVal === "" ||
    jobCardVal === null ||
    jobCardVal === undefined ||
    (Array.isArray(jobCardVal) && jobCardVal.length === 0);

  if (isCustomerEmpty && isJobCardEmpty) {
        this._toastrService.error("Please select Customer and Job Card", "");
        this._mApp.HideLoader();
        return;
    }

if (isCustomerEmpty) {
            this._toastrService.error("Please select Customer", "");
            this._mApp.HideLoader();
            return;
        }

  if (isJobCardEmpty) {
        this._toastrService.error("Please select Job Card", "");
        this._mApp.HideLoader();
        return;
    }

    const dataToSend = {
      CustomerId: this.searchForm.controls["CustomerId"].value,
      LabIds: this.searchForm.controls["LabIds"].value,
      SampleNo: this.searchForm.controls["SampleNo"].value,
      SpId: this.searchForm.controls["SpId"].value,
      JobCardNumber: this.searchForm.controls["JobCardNumber"].value,
      SampleStatusTypeId: this.searchForm.controls["SampleStatusTypeId"].value,
    }

    this._http.post(this._appUrl.OilAnalysisExportExcel, dataToSend)
        .subscribe(
            res => {             
                this._mApp.HideLoader();
                 if(res && res.status === 204) {
                this._toastrService.error("No data available for the selected criteria", "");
                return;
              }
                const downloadUrl = res.json().Result;

                if (downloadUrl && downloadUrl !== "" && downloadUrl !== null && downloadUrl !== undefined) {
                    window.open(downloadUrl, '_blank');
                    this._toastrService.success("Excel report exported successfully", "");
                } else {
                    this._toastrService.error("Invalid response from server", "");
                }
            },
            error => {
                console.error("Error exporting report:", error);
                this._mApp.HideLoader();
                if(error && error.Response && error.Response.status === 204) {
                this._toastrService.error("No data available for the selected criteria", "");
                } else {
                this._toastrService.error("Error occured in exporting report", "");
                }
            }
        );
}
  OnReset() {
    this.searchForm.reset();
    this.searchForm.controls["LabIds"].setValue([]);
        this.searchForm.controls['CustomerId'].setValue(this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0);
    // this.GetAreas();
    // this.GetOilGrades();
    this.lstJobCards = null;
    this.GetCustomers();
    this.BindJobCard(this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0);
    if (this._mApp.userTypeId == 2) {
      var currentUser = JSON.parse(localStorage.getItem('currentUser'));
      let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
      this.searchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
    }
  }
}
